<template>
  <ExActionsPopUp
    :value="show"
    headline="Reactivate Department"
    :icon="'department_icon'"
    :htmlInfo="info"
    :destructive="false"
    actionLabel="Reactivate"
    :centerHeadline="true"
    actionsTopSpacing="32px"
    @onAction="handleReactivate"
    @input="$emit('onClose')"
    data-testid="reactivate-department-popup"
    :applyBorderClass="true"
    :backgroundPatternBottomRight="true"
    :width="450"
    :orgObjectType="'Department'"
  >
  </ExActionsPopUp>
</template>
<script setup>
import { computed } from "vue";
import ExActionsPopUp from "@components/common/ExActionsPopUp.vue";

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
  name: {
    type: String,
    default: "",
  },
});

const emit = defineEmits(["onReactivate", "onClose"]);

const formattedInfo = computed(() => {
  return `<div style="max-width: 414px; margin: 0 auto; margin-top: 26px;">You are about to reactivate Department ${props.name}.</div>`;
});

const info = computed(() => {
  return formattedInfo.value;
});

const handleReactivate = (updatedName) => {
  emit("onReactivate", updatedName);
};
</script>
